














import pathToRegexp from 'path-to-regexp';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { RouteRecord, Route } from 'vue-router';
import { translateRouteTitle } from '@/utils/permission';

@Component({
  name: 'AppNavbarBreadcrumbs',
})
export default class extends Vue {
  private breadcrumbs: any[] = [];

  @Watch('$route')
  private onRouteChange(route: Route) {
    // if you go to the redirect page, do not update the breadcrumbs
    if (route.path.startsWith('/redirect/')) {
      return;
    }
    this.getBreadcrumb();
  }

  created() {
    this.getBreadcrumb();
  }

  private getBreadcrumb() {
    let matched = this.$route.matched.filter(
      item => item.meta && item.meta.title
    );
    const first = matched[0];
    // if (!this.isHome(first)) {
    //   matched = [
    //     { path: '/home', meta: { title: 'Home' } } as RouteRecord,
    //   ].concat(matched);
    // }
    const items = matched.filter(
      item => item.meta && item.meta.title && item.meta.breadcrumb !== false
    );
    const result = [];
    for (let i = 0; i < items.length; i++) {
      result.push(
        this.routeRecordToBreadcrumb(
          items[i],
          items[i].redirect === 'noredirect' || i === items.length - 1
        )
      );
    }
    this.breadcrumbs = result;
  }

  private isHome(route: RouteRecord) {
    const name = route && route.name;
    if (!name) {
      return false;
    }
    return name.trim().toLocaleLowerCase() === 'Home'.toLocaleLowerCase();
  }

  private pathCompile(path: string) {
    const { params } = this.$route;
    const toPath = pathToRegexp.compile(path);
    return toPath(params);
  }

  private routeRecordToLink(item: RouteRecord) {
    const { redirect, path } = item;
    if (redirect) {
      return redirect as string;
    }
    return this.pathCompile(path);
  }

  private routeRecordToBreadcrumb(item: RouteRecord, disabled: boolean) {
    return {
      text: item.meta.title,
      disabled: disabled,
      to: this.routeRecordToLink(item),
    };
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
